// extracted by mini-css-extract-plugin
export var checkmark = "flowStepMobileAccount-module--checkmark--81721";
export var container = "flowStepMobileAccount-module--container--80efc";
export var dash = "flowStepMobileAccount-module--dash--eb65f";
export var fadeIn = "flowStepMobileAccount-module--fade-in--37868";
export var imageWrapper = "flowStepMobileAccount-module--imageWrapper--44f63";
export var links = "flowStepMobileAccount-module--links--229c4";
export var scaleIn = "flowStepMobileAccount-module--scaleIn--c3bf1";
export var subtitle = "flowStepMobileAccount-module--subtitle--664a4";
export var wrapper = "flowStepMobileAccount-module--wrapper--b1562";